import { useScrollStore } from '@store/common/useScrollStore.js'

export const restoreScroll = (key) => {
  const scrollY = useScrollStore.getState().getScrollY(key)

  requestAnimationFrame(() => {
    setTimeout(() => {
      window.scrollTo(0, scrollY)
      document.documentElement.scrollTop = scrollY
      document.body.scrollTop = scrollY
      useScrollStore.getState().clearScrollY(key)
    }, 10)
  })
}
